import { t } from "@lingui/macro";
import { Book, Question, Info, ArrowRight } from "@phosphor-icons/react";
import { Button, Tooltip } from "@stylingcv/ui";
import { cn } from "@stylingcv/utils";

import { useResumeStore } from "@/client/stores/resume";

export const InformationSection = () => {
  const setValue = useResumeStore((state) => state.setValue);
  const metadata = useResumeStore((state) => {
    try {
      return state.resume.data.metadata;
    } catch {
      return {};
    }
  });

  return (
    <div className="space-y-4">

      {/* Header */}
      <div className="flex items-center gap-3 mb-6 border-b border-gray-200 pb-5">
        <div className="flex size-10 items-center justify-center rounded-xl bg-gray-100">
          <Info size={20} className="text-gray-600" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-[#16344c]">{t`Information`}</h3>
          <p className="text-[11px] text-gray-400">{t`Resume info`}</p>
        </div>
        <div className="ml-auto">
          <Tooltip content={t`Learn more`}>
            <Button size="icon" variant="ghost" className="h-8 w-8 text-gray-400 hover:bg-gray-100 hover:text-[#16344c] transition-colors">
              <Question size={18} />
            </Button>
          </Tooltip>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 p-5 space-y-6">
      <div className="space-y-6">
        {/* Help / Docs Card */}
        <div className="relative overflow-hidden rounded-2xl border border-[#268599]/20 bg-white p-1 group shadow-sm">
          {/* Subtle glow on hover */}
          <div className="absolute -inset-10 bg-gradient-to-br from-[#268599]/5 via-[#268599]/3 to-transparent blur-2xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity"></div>

          <div className="relative z-10 bg-gray-50 rounded-xl p-5 border border-gray-100 flex flex-col items-center text-center">

            <div className="w-16 h-16 rounded-full bg-[#268599]/10 flex items-center justify-center mb-4 border border-[#268599]/20 group-hover:scale-110 transition-transform duration-500">
              <Book size={28} weight="duotone" className="text-[#268599]" />
            </div>

            <h3 className="text-base font-bold text-[#16344c] tracking-wide mb-2">{t`Need a little help?`}</h3>
            <p className="text-xs text-gray-500 leading-relaxed mb-6 px-4">
              {t`Dive into our comprehensive guides, template instructions, and best practices to build the perfect resume.`}
            </p>

            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-full h-11 rounded-lg bg-[#268599] text-white font-bold text-sm tracking-wide flex items-center justify-center gap-2 hover:bg-[#16344c] hover:shadow-[0_0_20px_rgba(38,133,153,0.3)] transition-all"
            >
              {t`Read Documentation`}
              <ArrowRight size={16} weight="bold" />
            </a>
          </div>
        </div>

      </div>
      </div>{/* end white card */}
    </div>
  );
};
